import { Component, OnInit, Input } from '@angular/core';
import { IStore } from '../../services/store.service';
import { ModalController } from '@ionic/angular';
import { IAddress } from 'src/app/shared/services/address.service';
import { OrderType } from '../../pages/list-page/list-page.component';
//import * as moment from 'moment';
import moment from 'moment';
import { Storage } from '@ionic/storage';
import { IFinalizeThreeds, IOrder, IOrderItem, ISeatInfo, IThreedsData } from '../../services/order.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SettingService } from 'src/app/shared/services/setting.service';

export interface IDisplayTaxes {
  provinceTaxId: string;
  name: string;
  percent: number;
  amount: number;
  amountDisplay: string;
  translatedName: string;
  language: string;
}

export interface ICustomerTransactionEmail {
    isBlockedCard: boolean;
    isBlockedEmail: boolean;
    errorMessage: string;
    brandName: string;
    orderId: string;
    orderNumber: number;
    customerName: string;
    customerEmail: string;
    customerPhone: string;
    ghostedPaymentNumber: string;
    orderDate: Date;
    storeName: string;
    invoiceNumber: string;
    recipientDetail: string;
    total: number;
    subtotal: number;
    deliveryFee: number;
    tip: number;  
    deliveryAddress: IAddress;
    storeAddress: IAddress;
    isDelivery: boolean;
    isShipping: boolean;
    note: string;
    totalPrice: number;
    order: IOrder;
    info: ICustomerTransactionEmailInfo;
    translations: { [key: string]: string };
    reservedTime: string;
    storePhone: string;
    onlyGiftCard: boolean;
    useGiftCard: boolean;
    giftCardConsNumber: string;
    creditCardAmount: number;
    giftCardAmount: number;
    billingAddress: string;
    ghostedGiftCardNumber: string;
    taxes: IDisplayTaxes[];
    gainedReward: boolean;
    ghostedRewardCard?: string;
    gainedPoint?: number;
    pointBalance?: number;
    logoUrl?: string;
    logoFileName?: string;
    isEstimatedTimeUsed: boolean;
    estimatedTime: string;
    rebateAmount: string;
    isRebateApplied: boolean;
    isRebateBeforeTax: boolean;
    isRebateAfterTax: boolean;
    isRebateDelivery: boolean;
    isDoorDashDrive: boolean;
    convenienceFee: number;
    amountLeftToPay?: number;
    seatInfo?: ISeatInfo;
    cloverRequireChallenge: boolean;
    cloverThreeDsData: IThreedsData;
}

export interface ICustomerTransactionEmailInfo {
    contactEmail: string;
    formatedAddress: string;
    legalGst: string;
    legalQst: string;
    phoneNumber: string;
}

export interface IReceiptOrder {
    store: IStore;
    orderItems: IReceiptOrderItem[];
    note: string;
    _deliveryType: OrderType;
}

export interface IReceiptOrderItem {
    allergies: string;
    name: string;
    note: string;
    options:IReceiptOrderItemOption[];
    quantity: number;
    totalPrice: string;
}

export interface IReceiptOrderItemOption {
    name: string;
    quantity: number;
}

@Component({
    selector: 'app-receipt',
    templateUrl: './receipt.component.html',
    styleUrls: ['./receipt.component.scss'],
    standalone: false
})
export class ReceiptComponent implements OnInit {
  title: string = 'Nav.Receipt';

  moment: any = moment;

  @Input() customerTransactionEmail : ICustomerTransactionEmail;
  @Input() remainingCartItems: IOrderItem[];

  logo!: SafeUrl;

  get hasAlcohol(){
    if(this.customerTransactionEmail){
      let index = this.customerTransactionEmail.order.orderItems.findIndex(item => item.isAlcohol);
      return index > -1;
    }
    return false;
  } 

  constructor(private modalCtrl: ModalController,
    private storage: Storage,
    private setting: SettingService,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));

    if(this.remainingCartItems.length > 0){
      localStorage['cartStorage']=JSON.stringify(this.remainingCartItems);
    } else {
      localStorage.removeItem('cartStorage');
      localStorage.removeItem('StoreId');
      localStorage.removeItem('TimeLimit');
    }
    localStorage.removeItem('Coupon');
    this.storage.remove('cart')
  }

  async cancel() {
    await this.modalCtrl.dismiss(null);
  }

  formatAddress(address: IAddress) {
    return `${address.streetNumber} ${address.suiteNumber != null ? address.suiteNumber : ""} 
    ${address.streetType} ${address.street} ${address.streetDirection != null ? address.streetDirection : ""}
    ${address.city} ${address.postalCode}`;
  }
}
